export const subheaderWhitespace = 8;

export const rowHeights = {
  regular: 55,
  higher: 73,
  header: 38,
  subheader: 28 + subheaderWhitespace,
};

export const columnMargin = 24;
